import React from "react";
import { useLocation } from "react-router-dom";
import styled, { keyframes, css } from "styled-components";

/**
 * IntroFade — wraps a page so it fades + settles in *only* when the user
 * arrives from the Home intro (navigate(..., { state: { fromIntro: true } })).
 *
 * Reached by direct URL, refresh, or in-app navigation → no animation,
 * because location.state.fromIntro is absent.
 *
 * Usage in App.jsx routes:
 *   <Route
 *     path="dashboard"
 *     element={
 *       <IntroFade>
 *         <DashboardCustomerUnsecured />
 *       </IntroFade>
 *     }
 *   />
 *
 * The wrapped page needs no changes — it doesn't know the fade exists.
 */

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const Fade = styled.div`
  /* Echoes the Home card's entrance so leaving the intro and landing
     on the dashboard feel like one continuous motion. */
  ${(p) =>
    p.$animate &&
    css`
      animation: ${fadeIn} 5.2s ease-out both;
    `}
`;

export default function IntroFade({ children }) {
  const { state } = useLocation();
  const fromIntro = Boolean(state?.fromIntro);
  console.log("State from intro", state)

  return <Fade $animate={fromIntro}>{children}</Fade>;
}
